module.exports = __webpack_public_path__ + "07_long_grey.82a27681.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/07_long_grey.png
// module id = 4EtU
// module chunks = 0